import React from 'react';

export const IconRestaurent = ({ fill }: { fill: string }) => (
  <svg width="17" height="16" viewBox="0 0 17 16" fill="none">
    <path
      d="M7.83333 5.99998H6.5V1.33331H5.16667V5.99998H3.83333V1.33331H2.5V5.99998C2.5 7.41331 3.60667 8.55998 5 8.64665V14.6666H6.66667V8.64665C8.06 8.55998 9.16667 7.41331 9.16667 5.99998V1.33331H7.83333V5.99998ZM11.1667 3.99998V9.33331H12.8333V14.6666H14.5V1.33331C12.66 1.33331 11.1667 2.82665 11.1667 3.99998Z"
      fill={fill}
    />
  </svg>
);
